import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';

import { addVendor, updateVendor } from 'redux/actions';

const departments = [ "Kaccha", "Hand", "Computer", "Jhik", "Crystal", "Patchwork" ];

const VendorDetails = (props) => {

  const [values, setValues] = useState({
    name: props.vendorInfo.name,
    phone: props.vendorInfo.phone,
    department: props.vendorInfo.department,
    joiningDate: props.vendorInfo.joiningDate
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if(props.update) {
      const updatedVendor = {
        id: props.vendorInfo.id,
        updates: {
          name: values.name,
          phone: values.phone,
          joiningDate: new Date(values.joiningDate)
        }
      };
      props.updateVendor(updatedVendor);
    }
    else {
      const newVendor = {
        displayId: props.vendorInfo.displayId,
        department: values.department,
        name: values.name,
        phone: values.phone,
        joiningDate: new Date(values.joiningDate)
      };
      props.addVendor(newVendor, props.activeUserId);
    }
    
    props.cancelAddUpdate();
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited later"
          title="Vendor"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the name"
                label="Name"
                name="name"
                onChange={handleChange}
                required
                value={values.name}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Phone Number"
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                required
                value={values.phone}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please select the Department"
                label="Select Department"
                name="department"
                onChange={handleChange}
                disabled={props.update}
                select
                SelectProps={{ native: true }}
                value={values.department}
                variant="outlined"
              >
                {departments.map((value) => (
                  <option
                    key={value}
                    value={value}
                  >
                    {value}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                type="date"
                fullWidth
                helperText="Please select the Joining Date"
                name="joiningDate"
                onChange={handleChange}
                required
                value={values.joiningDate}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save details
          </Button>
          <Button sx={{ mx: 1 }} onClick={props.cancelAddUpdate.bind(this)}>
            Cancel
          </Button>
        </Box>
      </Card>
    </form>
  )
};

export default connect (null, {addVendor, updateVendor}) (VendorDetails);